<template>
  <div class="wrap">
    <Navbar background="transparent" fixed />
    <!-- <ServiceBtn textShow /> -->
    <div class="icon_lang" @click="showLang">
      <img src="../../assets/new/lang_.png" class="langicon" alt="">
    </div>

    <div class="deline"></div>
    <div class="deline1"></div>
    <div class="partners">
      <div class="partners_item">
        <img src="../../assets/login/1.png" alt="">
        <span>{{ $t('水晶宫') }}</span>
      </div>
      <div class="partners_item">
        <img src="../../assets/login/2.png" alt="">
        <span>{{ $t('皇家马德里') }}</span>
      </div>
      <div class="partners_item">
        <img src="../../assets/login/3.png" alt="">
        <span>{{ $t('国际米兰') }}</span>
      </div>
      <div class="partners_item">
        <img src="../../assets/login/4.png" alt="">
        <span>{{ $t('AC米兰') }}</span>
      </div>
    </div>
    <div class="form_wrap_bar">
      <!-- <div class="logo">
        <img :src="require('@/assets/logo/login.png')" class="logo_img" alt="" />
      </div> -->
      <div class="tab">
        <div class="tab_item" :class="index == tabNum ? 'active_item' : ''" v-for="item, index in tab" :key="index"
          @click="tabNum = index">
          {{ $t(item) }}
        </div>
      </div>
      <LoginForm :formList="formData" cancelText="Login.registrasi" confirmText="newAdd.Login" readText="记住"
        :getRemember="true" :tab-num="tabNum" @cancel="toRegiste" @submit="onSubmit" isRead>
      </LoginForm>
      <div class="btns">
        <div class="btn" @click="toRegiste">
          <img src="../../assets/login/signup.png" alt="">
          <span>{{ $t('立即注册') }}</span>
        </div>
        <div class="btn" @click="getHome">
          <img src="../../assets/login/kefu.png" alt="">
          <span>{{ $t('在线客服') }}</span>
        </div>
      </div>
      <!-- <div class="already_account">
        <span>{{ $t("没有账号") }}</span>
        <span @click="toRegiste" class="register">{{ $t("page.registrasi") }}</span>
      </div> -->
    </div>

    <van-action-sheet v-model="show2" :actions="verConfig.lans || Lans" @close="onClose" @select="onSelect" />
  </div>
</template>

<script>
import Navbar from "@/components/JNav";
import { Icon, Image as VImg, Toast, ActionSheet } from "vant";
import LoginForm from "./components/form.vue";
import Cookies from "js-cookie";
import { SEND_SMS_CODE, LOGIN, HOME_IMG } from "@/api";
import { getNewPhone } from "@/utils/tools";
import ServiceBtn from "@/components/serviceBtn";
import verConfig from "@/utils/verConfig";
import { $post } from "../../utils/request";
import { Lans, getLanguage } from "@/i18n";
export default {
  components: {
    Icon,
    VImg,
    [ActionSheet.name]: ActionSheet,
    LoginForm,
    ServiceBtn,
    Navbar,
  },
  data() {
    this.Lans = Lans;
    return {
      langicon: "",
      langtext: "",
      show2: false,
      formList: [{
        key: "email",
        flag: true,
        // icon: "icon-yonghuming",
        label: "Login.emailInput",
        rules: [{ required: true, message: this.$t("Login.emailInput") }],
        img: require('../../assets/login/email.png'),
      },
      {
        key: "userphone",
        flag: true,
        // icon: "icon-yonghuming",
        label: "Login.nameInput",
        rules: [{ required: true, message: this.$t("hint.usernameEnter") }],
        needTrue: true
      },
      {
        label: "Login.pwdInput",
        type: "password",
        key: "userpass",
        // icon: "icon-zhanghumima",
        flag: true,
        rules: [{ required: true, message: this.$t("hint.passwordEnter") }],
        isPassword: true,
        img: require('../../assets/login/password.png'),
      },
      ],
      tab: ['loginType.phone', 'loginType.email'],
      tabNum: 0
    };
  },
  computed: {
    formData() {
      if (this.tabNum == 0) {
        return this.formList.filter(item => item.key != 'email');
      }
      return this.formList.filter(item => item.key != 'userphone');
    }
  },
  created() {
    Lans.forEach((item) => {
      if (item.value == getLanguage()) {
        this.langicon = item.icon;
        this.langtext = item.name;
      }
    });
  },
  methods: {
    async getHome(num = 0) {
      this.$store.dispatch('toService');
      // window.ssq.push('chatOpen');
      return;
      Toast.loading()
      try {
        const { data } = await HOME_IMG();
        Toast.clear()
        if (data) {
          if (data[num]) return window.location.href = data[num].paramet.url;
          const find = data.find(item => item.paramet.url);
          window.location.href = find.paramet.url;
        }
      } catch (error) {
        Toast.clear();
      }
    },
    onSubmit(values, read) {
      Toast.loading({ duration: 0 });
      LOGIN({ ...values }) // http请求
        .then((r) => {
          if (r.data.ret === 1) {
            this.$cookie.set("userInfo", JSON.stringify(r.data.data));
            this.$cookie.set("token", r.data.data.token);
            this.$cookie.set("the-pwd-state", this.checked);
            if (read) {
              if(this.tabNum == 0){
                this.$cookie.set(
                  "the-pwd-obj",
                  JSON.stringify({
                    userphone: values.userphone,
                    userpass: values.userpass,
                  })
                );
              }else{
                this.$cookie.set(
                  "the-email-obj",
                  JSON.stringify({
                    email: values.email,
                    userpass: values.userpass,
                  })
                );
              }
            } else {
              this.$cookie.remove("the-pwd-obj");
            }
          } else {
            Toast.clear();
            Toast(r.data.msg);
          }
          return r.data.ret;
        })
        .then(async (ret) => {
          if (ret == 1) {
            this.$store.dispatch("getSystemConfig");
            try {
              const res = await $post("/users/info");
              const { ret, msg, data } = res.data;
              if (ret == 1) {
                // this.LoadingShow = false;
                Toast.clear();
                this.$router.replace({ name: "goods" });
                this.$cookie.set("userInfo", JSON.stringify(data));
              }
            } catch (error) {
              console.error("登录错误", error);
              Toast.clear();
            }
          }
        })
        .catch((e) => {
          Toast.clear();
          console.log(e);
        });
    },
    toRegiste() {
      this.$router.push("/registrasi");
    },
    showLang() {
      this.show2 = true;
    },
    onClose() {
      this.show2 = false;
    },
    onSelect(e) {
      this.$i18n.Locale = e.value;
      this.changeLanguage(e.value);
      Cookies.set("lang", e.value);
      this.language = e.value;
      this.show2 = false;
      this.langicon = e.icon;
      this.langtext = e.name;
    },
  },
};
</script>

<style lang="less" scoped>
.wrap {
  background: var(--bg);
  min-height: 100vh;
  overflow: hidden;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-image: url("../../assets/login/bg.png");
  display: flex;
  align-items: center;
  // justify-content: center;
  flex-direction: column;

  /deep/ .van-nav-bar__left {
    .van-icon-arrow-left {
      color: var(--theme) !important;
    }
  }
  /deep/ .van-nav-bar--fixed{
    left: 50% !important;
    transform: translateX(-50%);
  }

  /deep/ .service_btn {
    position: fixed;
    top: calc(26rem / 16);
    right: calc(20rem / 16);
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }

  .icon_lang {
    position: fixed;
    // top: calc(10rem / 16);
    right: calc(20rem / 16);
    height: calc(46rem / 16);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    z-index:9;

    img {
      height: 35px;
      width: 35px;
      object-fit: contain;
      margin-right: 8%;
    }

    span {
      min-width: 55px;
      color: #fff;
      font-size: calc(14rem / 16);
    }
  }

  .deline {
    background: url('../../assets/login/login_logo.png') top / contain;
    background-repeat: no-repeat;
    width: 100%;
    height: 80px;
    margin: 0 auto;
  }

  .deline1 {
    background: url('../../assets/login/login_header.png') top / contain;
    background-repeat: no-repeat;
    width: 100%;
    height: 23px;
    margin: 0 auto;
    margin-top: 10px;
  }

  .partners {
    width: calc(100% - 40px);
    padding: 20px 0 10px;
    margin: 0 20px;
    display: flex;

    .partners_item {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 25%;

      img {
        width: 50px;
        height: 50px;
        display: block;
        object-fit: contain;
      }

      span {
        color: var(--theme);
        font-size: 12px;
        margin-top: 5px;
      }
    }
  }

  .form_wrap_bar {
    width: 90%;

    .logo {
      display: flex;
      justify-content: center;

      &_img {
        height: calc(80rem / 16);
        display: block;
      }
    }

    .tab {
      margin: 5px 16px 5px;
      padding: 5px;
      background: #ddd5c7;
      border-radius: 5px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .tab_item {
        flex: 1;
        text-align: center;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 5px;
        padding: 5px;
        color: #101010;
        font-weight: 700;
      }

      .active_item {
        background: #fff;
        color: #b98b37;
      }
    }
  }

  .nav {
    // height: calc(50rem / 16);
    color: var(--textColor);
    display: flex;
    align-items: center;
    margin: calc(26rem / 16) calc(17rem / 16) 0;

    .back {
      transform: rotate(90deg);
    }

    .title {
      font-size: calc(24rem / 16);
      margin-left: calc(14rem / 16);
    }
  }

  .btns {
    display: flex;
    align-items: center;
    justify-content: space-around;
    gap: 10px;
    margin: 10px auto;

    .btn {
      background: url('../../assets/login/btn1.png') no-repeat 50% / contain;
      font-size: 14px;
      padding: 20px 0 30px;
      color: #1b4983;
      display: flex;
      width: 30%;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      img {
        width: 30px;
        height: 30px;
        display: block;
      }

      span {
        margin-top: 10px;
      }
    }
  }

  .already_account {
    text-align: center;
    color: var(--light);
    font-size: calc(14rem / 16);
    margin-top: calc(15rem / 16);
    white-space: pre-wrap;

    .register {
      color: var(--yellow);
      cursor: pointer;
      text-decoration: underline;
    }
  }
}
</style>
